import { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './style.module.scss';

const CouponBanner = ({ coupon, isHybrid }) => {
  const [isFixed, setIsFixed] = useState(false);
  useEffect(() => {
    let OFFSET = 0;
    if (!isHybrid) {
      const { offsetHeight, offsetTop } = document.querySelector(
        '.categories-nav-wrapper-placeholder, .cool3c-categories-nav-wrapper-placeholder'
      );
      OFFSET = offsetHeight + offsetTop;
    }
    const callback = () => {
      const windowScroll =
        (document.documentElement && document.documentElement.scrollTop) ||
        document.body.scrollTop;
      setIsFixed(windowScroll >= OFFSET);
    };

    window.addEventListener('scroll', callback);
    return () => {
      window.removeEventListener('scroll', callback);
    };
  }, [isHybrid]);

  return (
    <Fragment>
      <section
        className={classNames(styles.couponBanner, {
          [styles.couponBannerFixed]: isFixed
        })}
      >
        <i className={`icon-coupon-regular ${styles.couponBannerIcon}`} />
        <span>{coupon.description}</span>
      </section>
      {isFixed && <div className={styles.couponBannerEmptyHolder} />}
    </Fragment>
  );
};

CouponBanner.propTypes = {
  coupon: PropTypes.shape({
    description: PropTypes.string
  }).isRequired,
  isHybrid: PropTypes.bool.isRequired
};

export default CouponBanner;
